
<div class="col px-0 pr-xl-5 mb-5 fds" v-if="shouldShowComponent(objectModelPropertyType)">
  <label
    :for="`entry_field_${propertyClientId}`"
    :class="{required: objectModelProperty.is_required}"
    v-tooltip.wrap="canEdit ? null : tooltip"
  >
    {{ propertyLabelTitle }}<required-indicator v-if="objectModelProperty.is_required" />
  </label>
  <validation-error-wrapper :object-model="objectModel" :property-client-id="propertyClientId">
    <component
      :is="getComponentForPropertyType(objectModelPropertyType)"
      :id="`entry_field_${propertyClientId}`"
      class="mb-0"
      :class="{ 'read-only' : !canEdit }"
      :property-client-id="propertyClientId"
      :object-model="objectModel"
      v-bind="getAdditionalAttrs(objectModelProperty)"
      :entry="objectModelEntry"
      v-model="objectModelEntry[`f_${propertyClientId}`]"
      @input="revalidate"
      :isDetailViewEdit="isDetailViewEdit"
      :format-as-percentage="formatAsPercentage"
      @queue-upload-for-deletion="queueUploadForDeletion"
      :disabled="!canEdit"
      :disabled-tooltip="tooltip"
      :is-read-only="!canEdit"
    ></component>
    <span v-if="showRangeMessage" :class="rangeMessageClass">
      {{rangeMessage}}
    </span>
  </validation-error-wrapper>
</div>
